const getRealColour = c => {
    switch (c) {
        case 'sd-black':
            return '#141414'
        case 'sd-blue':
            return '#3353FF'
        case 'sd-orange':
            return '#F14F1D'
        case 'sd-beige':
            return '#EAE4E4'
        case 'sd-white':
            return '#FFFFFF'
        default:
            return c
    }
}

export default getRealColour
